import type { FC } from "react";

// This page is only needed to have a route that redirects /travel/membership-pages/#<pages> to /travel/membership-pages/<pages>
const RootRedirectionPage: FC = () => null;

export default RootRedirectionPage;
